<template>
  <OnClickOutside :do="close">
    <nav
      class="xl:inline-flex flex-col xl:flex-row w-full xl:w-auto h-full xl:relative overflow-auto xl:overflow-visible xl:items-center"
      :class="[opened ? 'flex' : 'hidden']"
    >
      <div
        v-for="record in records"
        :key="record.id"
        class="relative block xl:inline-block xl:ml-5 border-t border-solid xl:border-none"
      >
        <a
          v-if="!record.subs.length"
          :href="record.url"
          v-text="record.label"
          :rel="record.rel"
          :target="record.target"
          class="block p-3 xl:px-0 xl:py-2 text-sm leading-5 text-body font-normal cursor-pointer"
        ></a>
        <template v-else>
          <div
            class="flex flex-row items-center p-3 xl:px-0 xl:py-2 text-sm leading-5 text-body font-normal cursor-pointer"
            @click="select(record.id)"
          >
            <span class="flex-auto" v-text="record.label"></span>
            <span class="flex-none xl:pl-2">
              <svg
                v-if="!isSelected(record.id)"
                class="h-4 w-4 text-gray-400"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
              <svg
                v-else
                class="h-4 w-4 text-gray-400"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.707 7.05L10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z"
                />
              </svg>
            </span>
          </div>
          <DropDown
            v-show="isSelected(record.id)"
            :records="record.subs"
            @close="close"
            class="xl:absolute xl:top-10 xl:right-0 border-t border-gray-300"
          />
        </template>
      </div>
      <ShowIfAuthenticated v-slot="{ isAuth }">
        <ClickAction
          v-if="isAuth"
          :action="logoutUrl"
          behaviour="redirect"
          v-slot="{ call, processing }"
        >
          <div
            class="relative block xl:inline-block xl:ml-5 border-t border-solid xl:border-none"
          >
            <a
              @click="call"
              v-if="!processing"
              class="block p-3 xl:px-0 xl:py-2 text-sm leading-5 text-body font-normal cursor-pointer"
            >
              <span class="fas fa-lock fa-fw"></span> Logout
            </a>
            <a
              v-else
              class="block p-3 xl:px-0 xl:py-2 text-sm leading-5 text-body font-normal cursor-pointer"
            >
              <span class="fas fa-spinner fa-spin"></span> Logout
            </a>
          </div>
        </ClickAction>
      </ShowIfAuthenticated>
    </nav>
  </OnClickOutside>
</template>
<script>
import DropDown from './DropDown';
import { OnClickOutside } from '@ssdcode/cms-partials';
import ClickAction from '../../../src/components/Click/ClickAction';
import SearchButton from '../../../src/components/Search/SearchButton';
import ShowIfAuthenticated from '../../../src/components/ShowIfAuthenticated';
export default {
  name: 'MainNavigation',
  components: {
    DropDown,
    ClickAction,
    SearchButton,
    OnClickOutside,
    ShowIfAuthenticated,
  },
  props: {
    records: {
      type: Array,
      default: () => {
        return {};
      },
    },
    logoutUrl: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selected: null,
      opened: false,
    };
  },
  created() {
    const listener = opened => (this.opened = opened);
    window.EventBus.listen('main-navigation-toggled', listener);

    this.$once('hook:beforeDestroy', () => {
      window.EventBus.unlisten('main-navigation-toggled', listener);
    });
  },
  methods: {
    isSelected(index) {
      return this.selected === index;
    },
    select(index) {
      this.selected = this.isSelected(index) ? null : index;
    },
    close() {
      if (this.selected === null) {
        return;
      }
      this.selected = null;
    },
  },
};
</script>
